__turbopack_context__.v({
  "Attraction__lastCardImage": "PageCard-module-scss-module__yLjJIG__Attraction__lastCardImage",
  "announcementCard": "PageCard-module-scss-module__yLjJIG__announcementCard",
  "announcementCardBack": "PageCard-module-scss-module__yLjJIG__announcementCardBack",
  "announcementImg": "PageCard-module-scss-module__yLjJIG__announcementImg",
  "announcementInner": "PageCard-module-scss-module__yLjJIG__announcementInner",
  "announcementItem": "PageCard-module-scss-module__yLjJIG__announcementItem",
  "announcementItemProgramList": "PageCard-module-scss-module__yLjJIG__announcementItemProgramList",
  "announcementItemProgramListContainer": "PageCard-module-scss-module__yLjJIG__announcementItemProgramListContainer",
  "announcementSubtitle": "PageCard-module-scss-module__yLjJIG__announcementSubtitle",
  "announcementTitle": "PageCard-module-scss-module__yLjJIG__announcementTitle",
  "border": "PageCard-module-scss-module__yLjJIG__border",
  "borderRight": "PageCard-module-scss-module__yLjJIG__borderRight",
  "content": "PageCard-module-scss-module__yLjJIG__content",
  "contentParent": "PageCard-module-scss-module__yLjJIG__contentParent",
  "outline": "PageCard-module-scss-module__yLjJIG__outline",
  "programListContent": "PageCard-module-scss-module__yLjJIG__programListContent",
  "root": "PageCard-module-scss-module__yLjJIG__root",
  "subtitleRedirect": "PageCard-module-scss-module__yLjJIG__subtitleRedirect",
  "title": "PageCard-module-scss-module__yLjJIG__title",
  "titleDescription": "PageCard-module-scss-module__yLjJIG__titleDescription",
  "titleWithSubtitle": "PageCard-module-scss-module__yLjJIG__titleWithSubtitle",
  "underDesc": "PageCard-module-scss-module__yLjJIG__underDesc",
  "visibility": "PageCard-module-scss-module__yLjJIG__visibility",
});
